import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../components/spinner/Spinner';

const PAGE_MESSAGES = {
    EMPTY_SCHOOLS_MESSAGE: 'You have no active schools for the selected district.',
    EMPTY_CLASSES_MESSAGE: 'You have no active classes for the selected school.',
    EMPTY_STUDENTS_MESSAGE: 'You have no active students for this class.',
    EMPTY_DEFAULT_MESSAGE: 'The reporting page is not available for this grade level.',
    ERROR_MESSAGE: 'If you believe this is an error, please contact your enrollment administrator.',
};

const renderEmptyPage = (hasNoSchools, hasNoClasses, hasNoStudents) => {
    let message = PAGE_MESSAGES.EMPTY_DEFAULT_MESSAGE;

    if (hasNoStudents) {
        message = PAGE_MESSAGES.EMPTY_STUDENTS_MESSAGE;
    }

    if (hasNoClasses) {
        message = PAGE_MESSAGES.EMPTY_CLASSES_MESSAGE;
    }

    if (hasNoSchools) {
        message = PAGE_MESSAGES.EMPTY_SCHOOLS_MESSAGE;
    }

    return (
        <div className="empty-page text-center assessment-title mt-4">
            {message}
            <br />
            {PAGE_MESSAGES.ERROR_MESSAGE}
        </div>
    );
};

const isEmptyPage = (hasNoSchools, hasNoClasses, hasNoStudents, hasNoExpress) =>
    hasNoSchools || hasNoClasses || hasNoStudents || hasNoExpress;

const Page = ({
    isDataReady,
    hasNoSchools,
    hasNoClasses,
    hasNoStudents,
    hasNoExpress,
    children,
}) => {
    if (isEmptyPage(hasNoSchools, hasNoClasses, hasNoStudents, hasNoExpress))
        return renderEmptyPage(hasNoSchools, hasNoClasses, hasNoStudents);

    return !isDataReady ? <Spinner /> : children;
};

Page.defaultProps = {
    isDataReady: false,
    hasNoSchools: true,
    hasNoClasses: true,
    hasNoStudents: true,
    hasNoExpress: true,
    children: null,
};

Page.propTypes = {
    isDataReady: PropTypes.bool,
    hasNoSchools: PropTypes.bool,
    hasNoClasses: PropTypes.bool,
    hasNoStudents: PropTypes.bool,
    hasNoExpress: PropTypes.bool,
    children: PropTypes.element,
};

export default Page;
